import * as React from "react";
import { useHistory, Link, useParams } from "react-router-dom";
import styled from "styled-components/macro";
import NavBar from "../component/NavBar";
import { Progress, ProgressMobile } from "../component/Progress";
import { useRecommendation } from "../contexts/recommendation-context";
import { useQuestion } from "../utils/question";
import { useEffect } from "react";
import { NextButton, QuestionForm } from "../component/QuestionForm";
import * as colors from "../styles/colors";
import * as fonts from "../styles/fonts";
import * as mq from "../styles/mediaQueries";

const tabDescriptions = {
  family: {
    main: "Now, let’s work out your insurance cover needs.",
    sub: "Who all are there in your family ?",
  },
  earnings: { main: "Now, let's take a closer look at your Earnings!" },
  expenses: { main: "Okay, let's understand your Expenses!" },
  debt: { main: "Walk us through your Debts or Loans!" },
  savings: { main: "Now, let's move on to your Rainy Day funds!" },
};

function QuestionPage() {
  const { tab: currentTab, enquiryId } = useParams();
  const [tabChanged, setTabChanged] = React.useState("");
  const resetTabChanged = () => setTabChanged("");
  const { isFirstQuestion, currentQuestion } = useQuestion();

  const question = currentQuestion;

  const history = useHistory();

  const { answers } = useRecommendation();
  const { getNextQuestion } = useQuestion();

  const nextQuestion = getNextQuestion(question);

  useEffect(() => {
    if (answers[question.name]) {
      if (!nextQuestion) {
        history.push(`/result/${enquiryId}`);
        return;
      }

      const { tab, sequence } = nextQuestion;

      if (currentTab !== tab) setTabChanged(tab);

      history.push(`/question/${enquiryId}/${tab}/${sequence}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [answers]);

  return (
    <Page>
      <NavBar />
      <Progress />
      <ProgressMobile />
      <main
        css={`
          position: relative;
          max-height: 60vh;
          overflow: auto;
          /* margin-top: 3em; */

          /* display: flex;
          align-items: center;
          justify-content: center; */

          /* ::-webkit-scrollbar {
            width: 0;
          } */

          /* @media (max-height: 700px) {
            max-height: 49vh;
          } */

          ${mq.sm} {
            font-size: calc(16 * 100vw / 360);
            max-height: max-content;
          }
        `}
      >
        {!isFirstQuestion ? (
          <BackButton
            onClick={() => {
              resetTabChanged();
              history.goBack();
            }}
            to={`#`}
          >
            &lt;
          </BackButton>
        ) : null}
        {tabChanged ? (
          <div
            css={`
              padding-top: 6em;
              display: flex;
              flex-flow: column;
              align-items: center;

              ${mq.sm} {
                width: 90%;
                margin: auto;
              }
            `}
          >
            <div
              css={`
                font-size: 2.67em;
                max-width: 900px;
                margin: auto;
                text-align: center;
                font-family: ${fonts.two};
                line-height: 1.37;
                position: relative;
                margin-bottom: 1em;

                ${mq.sm} {
                  font-size: 1.6em;
                }

                &::after {
                  content: "";
                  position: absolute;
                  top: 100%;
                  background-color: #ecf4ff;
                  height: 0.3em;
                  left: 50%;
                  width: 90%;
                  transform: translate(-50%);
                  border-radius: 6px;
                }
              `}
            >
              {tabDescriptions[tabChanged].main}
            </div>
            {tabDescriptions[tabChanged].sub ? (
              <div
                css={`
                  color: #929292;
                  /* margin-top: 1.6em; */
                  font-size: 1.6em;
                  font-family: ${fonts.three};

                  ${mq.sm} {
                    font-size: 1em;
                  }
                `}
              >
                {tabDescriptions[tabChanged].sub}
              </div>
            ) : null}
            <NextButton onClick={resetTabChanged}>Next &gt;</NextButton>
          </div>
        ) : (
          <QuestionForm
            question={{ ...question, last_question: !nextQuestion }}
          />
        )}
      </main>
    </Page>
  );
}

export default QuestionPage;

const Page = styled.div`
  min-height: 100vh;
  min-width: 100vw;
  padding-top: 6em;
`;

const BackButton = styled(Link)`
  position: fixed;
  top: 50%;
  left: 0;
  transform: translate(100%, -50%);
  height: 2em;
  width: 2em;
  border-radius: 0.12em;
  border: 1px solid ${colors.disable1};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2em;
  color: ${colors.disable1};
  background-color: #fff;
  transition: 0.3s ease-in-out;
  text-decoration: none;
  &:hover {
    background-color: #000;
    color: #fff;
  }

  ${mq.sm} {
    display: none;
  }
`;
